import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-right-doodle.svg';
import MdmLink from '~/components/atoms/MdmLink.vue';
export default {
  name: 'Rebound',
  components: {
    MdmLink: MdmLink
  },
  props: {
    src: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    cta: {
      type: String,
      default: ''
    },
    withIcon: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      mobile: true
    };
  },
  mounted: function mounted() {
    this.mobile = this.isMobile();
  }
};